import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { PlatformAPIModal } from './platformapi-modal/platformapi.modal';
import { SettingsService } from '../../../settings.service';
import { PKIUrls } from 'src/app/constants/pkiurls.constants';
import { IdentityOrganisationApiClient } from 'src/app/services/api-clients/identity-organisation.api-client';
import { IdsForSettingsService } from '../../../ids-for-settings.service';
import { OrganisationPlugins, PermissionsEnum } from 'src/app/constants/settings.enum';
import { Plugin } from 'src/app/models/plugin';

@Component({
  selector: 'platformapi-setting',
  templateUrl: './platformapi-setting.component.html'
})
export class PlatformAPISettingComponent {
   
  public PlatformApiUrl: string = PKIUrls.PlatformApiUrl;
  @Output('UpdateOrganisationSettings') updateOrganisationSettings: EventEmitter<any> = new EventEmitter<any>();
  @Output('UpdateOrganisationPlugins') updateOrganisationPlugins: EventEmitter<any> = new EventEmitter<any>();
  @Input('plugin') plugin!: Plugin;
  organisation!: any;

  constructor(private settingsService: SettingsService,
    private modalService: NgbModal,
    private idsForSettingsService: IdsForSettingsService, private identityOrganisationApiClient: IdentityOrganisationApiClient) {
  }

  toggleShowPlugins(event: any) {
    let checked = (event.target as HTMLInputElement).checked;
    this.updateOrganisationPlugins.emit([{ PluginCode: this.plugin.code, Enabled: checked }]);
  }

  getCorrectPersmission(){
    if(this.plugin.code === OrganisationPlugins.AFAS){
      return PermissionsEnum.Perm_Afas;
    } else if(this.plugin.code === OrganisationPlugins.Visionplanner){
      return PermissionsEnum.Perm_Visionplanner;
    }
    return false;
  }

  dialog() {
    let ngbModalOptions: NgbModalOptions = {
      keyboard: false,
      centered: true,
      size: 'md',
      windowClass: 'dialog-bg-white'
    };
    const modalRef = this.modalService.open(PlatformAPIModal, ngbModalOptions);
    modalRef.componentInstance.pluginCode = this.plugin.code;

    modalRef.componentInstance.updateOrganisationSettings.subscribe(() => {
      modalRef.close();
    });
  }

}
